module.exports = __webpack_public_path__ + "media/images/samples/300x300/5-d029ce477814d81c2360841212f11989.jpg";